import React from 'react';
import { ScienceAssociation_9to12_2026 } from '../views';

const BlogNewsroomPage = () => {
return <ScienceAssociation_9to12_2026/>
};

export default BlogNewsroomPage;